import type { IDependentControl, IRItemCard } from '~/presentation/reports/common/type';

import { DependentDisableBanner } from './DependentDisableBanner';
import { BlockStack, Text } from '@shopify/polaris';
import { HelpInfo } from './HelpInfo';

interface ItemInfoSectionProps {
  info?: IRItemCard;
  thumbnail?: string;
  dependentControls?: IDependentControl[];
}

export const ItemInfoSection: React.FC<ItemInfoSectionProps> = ({
  info,
  thumbnail,
  dependentControls,
}) => {
  if (!info) return null;

  return (
    <BlockStack gap="300">
      <DependentDisableBanner info={info} dependentControls={dependentControls} />
      {thumbnail && <img src={thumbnail} alt="Metric info" />}
      <BlockStack gap="200">
        <BlockStack gap="100">
          <Text as="span" variant="headingMd" tone="subdued">
            {info.title}
          </Text>
          <Text as="span" variant="bodyMd" tone="subdued">
            <span dangerouslySetInnerHTML={{ __html: info.content }}></span>
          </Text>
        </BlockStack>
        {info.formula && (
          <div className="rounded-lg font-mono !text-bodySm p-4 bg-white">{info.formula}</div>
        )}
        <BlockStack gap="100">
          <HelpInfo info={info.helps} />
        </BlockStack>
      </BlockStack>
    </BlockStack>
  );
};
